import {L} from "../lt-ng/landcare-toolkit";
import {FeatureLayer, GroupLayer, ImageService} from "../@types/esri/Features";
import {MapService, SpatialReference} from "../@types/esri/MapService";
import {ProjectionLike} from "ol/proj";
import * as proj from 'ol/proj';

export module CustomLayerAPI {
    export enum CustomLayerType {
		WMTS = "WMTS",/*,
		WMS = "WMS"*/
		EsriImage = "EsriImage",
		// EsriRest = "EsriRest"
	}

	export interface CustomLayerState {
		id?: number;
		visible: boolean;
		included: boolean;
		minScale?: number;
		maxScale?: number;
		layerType: L.util.LayerType;
		order?: number;
		member?: number;
	}

	export interface CustomWMTSLayer extends CustomLayerState {
		kind: CustomLayerType.WMTS
		capabilitiesURL: string;
		identifier: string;
	}

	export interface CustomEsriImageLayer extends CustomLayerState {
		kind: CustomLayerType.EsriImage,
		url: string;
	}

	export type CustomLayer = CustomWMTSLayer | CustomEsriImageLayer; // | CustomWMSLayer;


	export function requestCustomLayers($http : ng.IHttpService) : ng.IHttpPromise<CustomLayer[]> {
		return $http.get<CustomLayer[]>('/api/CustomLayer').then(response => {
			response.data.forEach(cl => {
				cl.included = Boolean(cl.included);
				cl.visible = Boolean(cl.visible);
			});

			return response;
		});
	}

	const baseURLs = {
		"WMTS": '/api/WMTSCustomLayer',
		"EsriRest": '/api/EsriRestCustomLayer',
		"EsriImage": '/api/EsriImageCustomLayer',
	};

	function getURL(customLayer: CustomLayer) : string {
		const baseUrl = baseURLs[customLayer.kind] || '/api/CustomLayer';

		if (customLayer && customLayer.id) {
			return [baseUrl, customLayer.id || ''].join('/');
		} else {
			return baseUrl;
		}
	}

	export function deleteCustomLayer($http : ng.IHttpService, customLayer: CustomLayer) : ng.IHttpPromise<any> {
		if (customLayer && customLayer.id) {
			return $http.delete(getURL(customLayer));
		}
		return null;
	}

	export function saveCustomLayer($http : ng.IHttpService, customLayer: CustomLayer) : ng.IHttpPromise<CustomLayer> {
		const url = getURL(customLayer);
		if (customLayer.id) {
			return $http.put<CustomLayer>(url, customLayer);
		} else {
			let request = $http.post<CustomLayer>(url, customLayer);

			request.then((response) => {
				let data = response.data;
				customLayer.member = data.member;
				customLayer.id = data.id;
			});

			return request;
		}
	}

	export function projFromSpatialReference(spatialReference: SpatialReference): ProjectionLike {
		spatialReference = spatialReference || <any> {};
		if ('wkid' in spatialReference) {
			return proj.get(`EPSG:${spatialReference.wkid}`) || proj.get('' + spatialReference.wkid);
		} else if ('wkt' in spatialReference) {
			try {
				const ref = `customProjection-${(new Date())}`;
				(<any> window).proj4.defs(ref, spatialReference.wkt);
				return proj.get(ref);
			} catch (e) {
				console.warn(e);
			}
		}

		return null;
	}

	export function esriServiceName(service: GroupLayer | MapService | FeatureLayer | ImageService) {
		if (!service) return '';

		if ('documentInfo' in service && service.documentInfo) {
			const maybeTitle = service.documentInfo && service.documentInfo.Title || service.documentInfo.Subject;
			if (maybeTitle) return maybeTitle;
		}

		return (<any> service).name || (<any> service).serviceDescription || (<any> service).mapName || '';
	}

	export function esriServiceDescription(service: GroupLayer | MapService | FeatureLayer | ImageService) {
		if (!service) return '';

		if ('documentInfo' in service && service.documentInfo) {
			const mapService = <MapService> service;
			return (mapService.documentInfo && mapService.documentInfo.Comments) || mapService.description;
		}

		return service.description || '';
	}
}